import apis from "./index";

export const generateQR = async (userId, token) => {
  try {
    const response = await fetch(apis.generateOffer.generateQR, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        userId: userId
      }),
    });

    if (!response.ok) {
      throw new Error('Failed to generate QR code');
    }

    // Get the blob URL for the PNG image
    const blob = await response.blob();
    const imageUrl = URL.createObjectURL(blob);

    console.log("generateQR()::API", imageUrl);
    return imageUrl;
  } catch (e) {
    console.log("generateQR()::API::Error", e);
    throw e;
  }
};
